import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import App from './App';
import {BrowserRouter as Router, Route, Switch, Link} from "react-router-dom";
import {unregister} from './registerServiceWorker';
import Confirmation from "./components/Confirmation";
import QuickBook from './quickBook';

const hash = document.getElementById('bookat').getAttribute('data-token');

const chained = document.querySelector('div[id="bookat"][data-token]').getAttribute('data-chained') === 'yes';


ReactDOM.render(
    <Router>
        <Switch>
            <Route exact path={`/widget/booking/:id`} component={Confirmation} />
            <Route exact path={`/qb/:bookingInfoId`} component={QuickBook} />

            <Route
                path="/widget/:hashId"
                render={props => <App {...props} hashId={hash} chained={chained}/>}
            />
        </Switch>
    </Router>
    , document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js